import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface TDoubleOptionModalData {
  option1: string;
  option2: string;
  explanation?: string;
  option1Action: string;
  option2Action: string;
}

@Component({
    selector: 'app-double-option-modal',
    templateUrl: './double-option-modal.component.html',
    styleUrls: ['./double-option-modal.component.scss'],
    standalone: true,
    imports: [MatButton]
})
export class DoubleOptionModalComponent {
  @Output() public handleOption1 = new EventEmitter();
  @Output() public handleOption2 = new EventEmitter();
  constructor(@Inject(MAT_DIALOG_DATA) public data: TDoubleOptionModalData) {}

  public handleOption1Click(): void {
    this.handleOption1.emit();
  }

  public handleOption2Click(): void {
    this.handleOption2.emit();
  }
}
